import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M19.07 7.07c-3.91-3.91-10.24-3.91-14.14 0L0 12l4.93 4.93c3.91 3.91 10.24 3.91 14.14 0L24 12l-4.93-4.93zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z" }));
export default createSvgIcon(iconPath, "Show");
//# sourceMappingURL=ShowIcon.js.map